import { Card, Stack } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import { useState } from "react";
import { Constants } from "../Comman/Constants";

const Contact = () => {
  const [cardsVisible, setCardsVisible] = useState(true);

  const navigate = useNavigate();
  const handleShowTechnology = () => {
    setCardsVisible(false);

    navigate(paths.technology);
  };
  const handleShowDesign = () => {
    setCardsVisible(false);

    navigate(paths.design);
  };

  return (
    <Stack
      direction={"row"}
      gap={3}
      mx={10}
      height={200}
      justifyContent={"center"}
      alignItems={"center"}
      style={{ display: cardsVisible ? "flex" : "none" }}
    >
      <Card
        sx={{
          height: 150,
          width: { md: "35%", xs: "50%" },
          borderRadius: 10,
          border: "1px solid rgb(143, 175, 222)",
          "&:hover": { cursor: "pointer" },
        }}
        onClick={handleShowTechnology}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-evenly"}
          width={"100%"}
          height={150}
          sx={{
            transition: "background-color 0.5s ease", 
            "&:hover": {
              bgcolor: "rgba(142, 174, 222, 0.2)",
            },
          }}
        >
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            fontSize={25}
            color={"#194a89"}
            component={motion.div}
            initial={{ x: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
            fontFamily={Constants.fontFamilyJosefinSans}
          >
            TECHNOLOGY
          </Stack>
          <Stack
            justifyContent={"end"}
            alignItems={"end"}
            component={motion.div}
            initial={{ y: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
          >
            <img src="/images/nav-design-boy-1.svg" alt="" />
          </Stack>
        </Stack>
      </Card>
      <Card
        sx={{
          height: 150,
          width: { md: "35%", xs: "50%" },
          borderRadius: 10,
          border: "1px solid rgb(143, 175, 222)",
          "&:hover": { cursor: "pointer" },
        }}
        onClick={handleShowDesign}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-evenly"}
          width={"100%"}
          height={150}
          sx={{
            transition: "background-color 0.5s ease", 
            "&:hover": {
              bgcolor: "rgba(142, 174, 222, 0.2)",
            },
          }}
        >
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            fontSize={25}
            color={"#194a89"}
            component={motion.div}
            initial={{ x: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
            fontFamily={Constants.fontFamilyJosefinSans}
          >
            DESIGN
          </Stack>
          <Stack
            justifyContent={"end"}
            alignItems={"end"}
            component={motion.div}
            initial={{ y: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
          >
            <img src="/images/nav-design-girl.svg" alt="" />
          </Stack>
        </Stack>
      </Card>
      {/* <Card
        sx={{ height: 150, width: "30%", borderRadius: 10, border: '1px solid rgb(143, 175, 222)' }}
        onClick={handleShowBranding}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-evenly"}
          width={"100%"}
          height={150}
        >
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            fontSize={25}
            color={"#194a89"}
            component={motion.div}
            initial={{ x: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
          >
            BRANDING
          </Stack>
          <Stack
            justifyContent={"end"}
            alignItems={"end"}
            component={motion.div}
            initial={{ y: "50%", opacity: 0 }}
            transition={{
              duration: 1.2,
              type: "tween",
            }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.5 }}
          >
            <img src="/images/nav-design-boy-2.svg" alt="" />
          </Stack>
        </Stack>
      </Card> */}
    </Stack>
  );
};
export { Contact };
